import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Field, Input, Textarea } from '@fluentui/react-components';
import { useEffect, useState } from 'react';

export const SendOfferDialog = ({ open, defaultEmail, onOpenChange, onSend }: { open: boolean; defaultEmail: string; onOpenChange: (open: boolean) => void; onSend: (email: string, message: string, cc?: string) => void }) => {
  const [email, setEmail] = useState('');
  const [cc, setCc] = useState('');
  const [message, setMessage] = useState('Please find attached your commercial offer from CloudShift.');

  useEffect(() => {
    if (open) {
      setEmail(defaultEmail);
      setCc('');
      setMessage('Please find attached your commercial offer from CloudShift.');
    }
  }, [open, defaultEmail]);

  return (
    <Dialog open={open} onOpenChange={(_, data) => onOpenChange(data.open)}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Send offer</DialogTitle>
          <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Field label="Recipient email"><Input value={email} onChange={(_, data) => setEmail(data.value)} type="email" /></Field>
            <Field label="CC (optional)"><Input value={cc} onChange={(_, data) => setCc(data.value)} placeholder="email1@example.com, email2@example.com" /></Field>
            <Field label="Message"><Textarea rows={4} value={message} onChange={(_, data) => setMessage(data.value)} /></Field>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button appearance="primary" disabled={!email.trim()} onClick={() => onSend(email, message, cc || undefined)}>Send</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};